module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "i": "components_cart"
    }
  }, [_c('el-dialog', {
    attrs: {
      "custom-class": _vm.$store.state.app.cart_type === 4 ? 'sty' : '',
      "visible": _vm.$store.state.app.cart_popup,
      "size": "tiny",
      "title": _vm.title,
      "close-on-click-modal": false,
      "before-close": _vm.close
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.$store.state.app, "cart_popup", $event)
      }
    }
  }, [(false) ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.content),
      expression: "content",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt20",
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("暂不支持线上购买版权，请留下您的联系方式，我们会尽快联系您")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sub()
      }
    }
  }, [_vm._v("确 定")])], 1)] : [_c('div', {
    staticClass: "text-left pl100"
  }, [_c('div', {
    staticClass: "mt20 mb20 mt20"
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.$store.state.app.cart_type = 1
      }
    }
  }, [_c('div', {
    staticClass: "check-chout"
  }, [(_vm.$store.state.app.cart_type === 1) ? _c('span', {
    staticClass: "active-chouk"
  }) : _c('span', {
    staticClass: "chouk"
  })]), _vm._v(" "), _c('span', [_vm._v("购买版权")])])]), _vm._v(" "), _c('div', {}, [_c('label', {
    on: {
      "click": function($event) {
        _vm.$store.state.app.cart_type = 2
      }
    }
  }, [_c('div', {
    staticClass: "check-chout"
  }, [(_vm.$store.state.app.cart_type === 2) ? _c('span', {
    staticClass: "active-chouk"
  }) : _c('span', {
    staticClass: "chouk"
  })]), _vm._v(" "), _c('span', [_vm._v("购买实物")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.$store.state.app.cart_type = 3
      }
    }
  }, [_c('div', {
    staticClass: "check-chout"
  }, [(_vm.$store.state.app.cart_type === 3) ? _c('span', {
    staticClass: "active-chouk"
  }) : _c('span', {
    staticClass: "chouk"
  })]), _vm._v(" "), _c('span', [_vm._v("购买版权+实物")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("确 定")])], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d1872ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addCart.vue
// module id = 1000
// module chunks = 59